"use client";

import React from "react";
import { useApp } from "../AppProvider";

export default function HighlightBlock({ 
  title_en, 
  title_ar, 
  content_en, 
  content_ar, 
  background 
}: { 
  title_en: string, 
  title_ar?: string, 
  content_en?: string, 
  content_ar?: string, 
  background: "brand" | "teal" | "surface" 
}) {
  const { isRTL } = useApp();
  
  const title = isRTL ? (title_ar || title_en) : title_en;
  const content = isRTL ? (content_ar || content_en) : content_en;

  const bgStyles: Record<string, string> = {
    brand: "var(--gradient-brand)",
    teal: "linear-gradient(135deg, #2dd4bf 0%, #0891b2 100%)",
    surface: "rgba(255, 255, 255, 0.03)",
  };

  return (
    <section 
      style={{
        background: bgStyles[background],
        borderRadius: "2rem",
        padding: "3rem",
        marginBottom: "4rem",
        color: background === "surface" ? "var(--text-primary)" : "white",
        boxShadow: background === "surface" ? "0 4px 6px -1px rgba(0,0,0,0.1)" : "0 20px 25px -5px rgba(0,0,0,0.1)",
        backdropFilter: background === "surface" ? "blur(12px)" : "none",
        border: background === "surface" ? "1px solid rgba(255,255,255,0.1)" : "none",
        textAlign: isRTL ? "right" : "left",
      }}
      className={`highlight-block-${background}`}
    >
      <h3 style={{ 
        fontSize: "1.8rem", 
        fontWeight: 800, 
        marginBottom: "1rem",
        letterSpacing: "-0.01em",
        opacity: background === "surface" ? 1 : 0.9
      }}>
        {title}
      </h3>
      {content && (
        <p style={{ 
          fontSize: "1.1rem", 
          lineHeight: 1.6, 
          opacity: background === "surface" ? 0.8 : 0.9,
          maxWidth: "800px"
        }}>
          {content}
        </p>
      )}
    </section>
  );
}
